/* eslint-disable */
<template>
	<section class="ncd-bottom-container">
		<nav class="ncd-bottom-nav">
			<div
				class="ncd-nav-item"
				:class="{ active: activeItem === 'home' }"
				@click="onNav('home')"
			>
				<img :src="OIcon('home')" alt="Home" />
				<span>Home</span>
			</div>
			<div
				class="ncd-nav-item"
				:class="{ active: activeItem === 'jobs' }"
				@click="onNav('jobs')"
			>
				<img :src="OIcon('jobs')" alt="Jobs" />
				<span>Jobs</span>
			</div>
			<div class="ncd-nav-center-outer">
				<div class="ncd-nav-center" @click="onNav('interview')">
					<img
						src="../../assets/NewDashboard/Mobiledesign/instantinterview.png"
						alt="Instant Interview"
						class="ncd-nav-center-img"
					/>
				</div>
			</div>
			<div
				class="ncd-nav-item"
				:class="{ active: activeItem === 'prepare' }"
				@click="onNav('prepare')"
			>
				<img :src="OIcon('prepare')" alt="Prepare" />
				<span>Prepare</span>
			</div>
			<div
				class="ncd-nav-item"
				:class="{ active: activeItem === 'assess' }"
				@click="onNav('assess')"
			>
				<img :src="OIcon('assess')" alt="Assess" />
				<span>Assess</span>
			</div>
		</nav>

		<PaymentComingSoonModal
			:showModal.sync="showPaymentComingSoonModal"
			:fromInstantInterview="true"
		/>
	</section>
</template>

<script>
/* eslint-disable */
import activeHomeIcon from "../../assets/NewDashboard/sidebar/activehome.svg";
import homeIcon from "../../assets/NewDashboard/sidebar/home.svg";
import jobsIcon from "../../assets/NewDashboard/sidebar/jobs.svg";
import activeJobsIcon from "../../assets/NewDashboard/sidebar/activejobs.svg";
import practiceIcon from "../../assets/NewDashboard/sidebar/practiceinterview.svg";
import activePracticeIcon from "../../assets/NewDashboard/sidebar/activepracticeinterview.svg";
import skillset from "../../assets/NewDashboard/sidebar/skilltest.svg";
import activeSkillset from "../../assets/NewDashboard/sidebar/activeskilltest.svg";
import PaymentComingSoonModal from "@/views/MyProfile/PaymentComingSoonModal.vue";

export default {
	name: "NcdBottomContainer",
	components: {
		PaymentComingSoonModal,
	},
	props: {
		active: {
			type: String,
			default: "home",
		},
	},
	data() {
		return {
			showPaymentComingSoonModal: false,
			// Bottom-nav items mapped to their destination routes.
			routeMap: {
				home: { name: "Homepage" },
				jobs: { name: "JobSearch" },
				interview: { name: "InterviewKickstart" },
				prepare: { name: "InterviewKickstart" },
				assess: { name: "AssessmentMarketplace" },
			},
			// Tracks which nav item was tapped / is on the current route so the
			// active icon + text highlight follows navigation instead of being
			// stuck on "home".
			selected: null,
		};
	},
	computed: {
		activeItem() {
			// Last tapped item wins; otherwise fall back to the current route.
			if (this.selected) return this.selected;
			const map = {
				Homepage: "home",
				JobSearch: "jobs",
				InterviewKickstart: "prepare",
				AssessmentMarketplace: "assess",
			};
			const name = this.$route && this.$route.name;
			return map[name] || this.active;
		},
	},
	watch: {
		$route(route) {
			const map = {
				Homepage: "home",
				JobSearch: "jobs",
				TakeAiInterview: "prepare",
				AssessmentMarketplace: "assess",
			};
			this.selected = map[route && route.name] || null;
		},
	},
	methods: {
		onNav(id) {
			if (id === "interview") {
				this.showPaymentComingSoonModal = true;
				return;
			}
			this.selected = id;
			this.$emit("navigate", id);
			const route = this.routeMap[id];
			if (route) {
				this.$router.push(route).catch(() => {});
			}
		},
		// Return the right icon (normal vs active) for a nav item. Each item has
		// its own icon set; the selected one uses the "active" variant.
		OIcon(key) {
			const icons = {
				home: [homeIcon, activeHomeIcon],
				jobs: [jobsIcon, activeJobsIcon],
				prepare: [practiceIcon, activePracticeIcon],
				assess: [skillset, activeSkillset],
			};
			const [normal, active] = icons[key] || icons.home;
			return this.activeItem === key ? active : normal;
		},
		openInstantInterviewModal() {
			this.showPaymentComingSoonModal = true;
		},
	},
};
</script>

<style scoped>
@media (max-width: 1028px) {
	.ncd-bottom-container {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100%;
		background: #ffffff;
		box-shadow: 0px -2px 20px rgba(0, 0, 0, 0.1);
		padding: 0 12px;
		z-index: 100;
		padding-bottom: env(safe-area-inset-bottom);
	}
	.ncd-bottom-nav {
		display: flex;
		align-items: flex-end;
		justify-content: space-around;
		height: 58px;
		position: relative;
	}
	.ncd-nav-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 2px;
		flex: 1;
		height: 100%;
		font-family: "Montserrat", sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		color: #a2a2a2;
		cursor: pointer;
	}
	.ncd-nav-item.active {
		color: #4a7eff;
	}
	.ncd-nav-item img {
		opacity: 0.5;
	}
	.ncd-nav-item.active img {
		opacity: 1;
	}
	.ncd-nav-center {
		margin: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;
		flex: 1;
		padding-bottom: 6px;
		border-radius: 100px;
		cursor: pointer;
	}
	.ncd-nav-center-outer {
		width: 76px;
		height: 76px;
		background: #ffffff;
		border: 1px solid #e8e8e8;
		box-shadow: 0px -2px 5px rgba(255, 255, 255, 0.9),
			0px 4px 10px rgba(0, 0, 0, 0.1);
		border-radius: 100px;
		margin-bottom: 10px;
	}
	.ncd-nav-center-img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
}
</style>
